module.exports = __webpack_public_path__ + "search_logo_peng.png?69049346ef163d6a7b9a6a286a0bbbf3";